import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import BossCalcSmallProject from "./BossStatisticComps/BossCalcPageComps/BossCalcSmallProject";
import BossCalcBigProject from "./BossStatisticComps/BossCalcPageComps/BossCalcBigProject";

export default function BossCalcPage() {
  const { t } = useTranslation();
  const [mode, setMode] = useState("small");

  return (
    <div className="min-h-screen bg-gray-50">
      {/* ── Top bar ── */}
      <div className="bg-slate-900 px-4 py-2.5">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
          {/* Brand / title */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <span className="text-slate-500 text-xs font-bold uppercase tracking-widest hidden sm:inline">
              NeholEsek
            </span>
            <span className="text-slate-700 text-xs hidden sm:inline">|</span>
            <span className="text-white text-sm font-bold tracking-tight">
              {t("projectCalculator")}
            </span>
          </div>

          {/* Mode toggle */}
          <div className="flex gap-1 p-0.5 bg-slate-800 rounded-xl">
            <button
              onClick={() => setMode("small")}
              className={`px-3 sm:px-4 py-1.5 rounded-lg text-xs font-semibold transition-all ${
                mode === "small"
                  ? "bg-white text-slate-900 shadow-sm"
                  : "text-slate-400 hover:text-slate-200"
              }`}
            >
              {t("smallProject")}
            </button>
            <button
              onClick={() => setMode("big")}
              className={`px-3 sm:px-4 py-1.5 rounded-lg text-xs font-semibold transition-all ${
                mode === "big"
                  ? "bg-white text-slate-900 shadow-sm"
                  : "text-slate-400 hover:text-slate-200"
              }`}
            >
              {t("bigProject")}
            </button>
          </div>

          {/* Subtitle — hidden on very small screens */}
          <span className="text-slate-500 text-xs italic hidden sm:inline">
            {mode === "small"
              ? t("oneTimeFixedPriceEstimate")
              : t("monthByMonthBilling")}
          </span>
        </div>
      </div>

      {mode === "small" ? <BossCalcSmallProject /> : <BossCalcBigProject />}
    </div>
  );
}
